export default "__VITE_ASSET__D57_Ukga__"